export function buildWhatsAppUrl(message: string): string {
  return `https://wa.me/?text=${encodeURIComponent(message)}`;
}

export function openWhatsAppShare(message: string): void {
  const url = buildWhatsAppUrl(message);
  window.open(url, "_blank", "noopener,noreferrer");
}

export function buildPublicInviteShareMessage(
  body: string,
  password: string
): string {
  const trimmed = password.trim();
  if (!trimmed) return body;
  return `${body}\n\nContraseña: ${trimmed}`;
}

export async function shareOrWhatsApp(
  message: string,
  title = "Fulbito Stats"
): Promise<void> {
  if (navigator.share) {
    try {
      await navigator.share({ title, text: message });
      return;
    } catch {
      // user cancelled or share failed
    }
  }
  openWhatsAppShare(message);
}

export function formatTeamsShareMessage(
  teamANames: string[],
  teamBNames: string[],
  groupName?: string
): string {
  const header = groupName ? `⚽ ${groupName} — Teams\n\n` : "⚽ Teams for today\n\n";
  return (
    header +
    `*Team A*\n${teamANames.map((n) => `• ${n}`).join("\n")}\n\n` +
    `*Team B*\n${teamBNames.map((n) => `• ${n}`).join("\n")}\n\n` +
    "Generated with Fulbito Stats"
  );
}

export function formatScoreShareMessage(
  teamA: string,
  teamB: string,
  scoreA: number,
  scoreB: number,
  groupName?: string
): string {
  const header = groupName ? `⚽ ${groupName}\n` : "⚽ Match result\n";
  return `${header}${teamA} ${scoreA} - ${scoreB} ${teamB}\n\nLogged with Fulbito Stats`;
}

export function formatLeaderboardShareMessage(
  entries: { name: string; wins: number }[],
  groupName?: string
): string {
  const header = groupName ? `🏆 ${groupName} — Top 3\n\n` : "🏆 Top 3\n\n";
  const lines = entries
    .slice(0, 3)
    .map((e, i) => `${i + 1}. ${e.name} (${e.wins}W)`)
    .join("\n");
  return header + lines + "\n\nFulbito Stats";
}
